import { render, staticRenderFns } from "./classificationModel.vue?vue&type=template&id=0c469bcc&scoped=true"
import script from "./classificationModel.vue?vue&type=script&lang=js"
export * from "./classificationModel.vue?vue&type=script&lang=js"
import style0 from "./classificationModel.vue?vue&type=style&index=0&id=0c469bcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c469bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c469bcc')) {
      api.createRecord('0c469bcc', component.options)
    } else {
      api.reload('0c469bcc', component.options)
    }
    module.hot.accept("./classificationModel.vue?vue&type=template&id=0c469bcc&scoped=true", function () {
      api.rerender('0c469bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/classificationManage/classificationModel.vue"
export default component.exports